export default __webpack_public_path__ + "static/media/10.4a47babe.jpg";